import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import projectsData from "../Data/projectsData";
import "../Styles/Projects.css";

const Projects = () => {
  const location = useLocation();

  const ongoing = projectsData.filter(p => p.category === "ongoing");
  const completed = projectsData.filter(p => p.category === "completed");

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (

     <>
     <div className="project-image">
        <img src="/corporate/projects.png" alt="Projects Banner" />
     </div>
    <section className="projects-page">

     

    <h1>Our Projects</h1>

    <p>At Swastika Infra, our projects reflect our strong commitment to nation-building and infrastructure excellence. We are actively working on a diverse range of ongoing developments across multiple sectors.Our highway construction projects focus on building durable, safe, and high-quality roads that improve regional connectivity and contribute to economic growth. In the railway sector, our infrastructure and modernization projects are designed to enhance operational efficiency and overall performance.We are also developing metro infrastructure in key urban areas, supporting smart mobility through advanced transit systems and modern engineering practices.Alongside this, our renewable energy initiatives — including solar power projects and eco-friendly infrastructure — demonstrate our commitment to sustainability and India’s green energy vision.Through every project, Swastika Infra stands for innovation, timely delivery, superior quality, and reliable infrastructure development.</p>


      <h2 id="current">Ongoing Projects</h2>
      <section className="projects-grid" >
        {ongoing.map(project => (
          <Link to={`/project/${project.id}`} key={project.id} className="project-card">
            <img src={project.image} alt={project.title} />
            <div className="card-content">
              <h3>{project.title}</h3>
              <p>{project.location}</p>
            </div>
          </Link>
        ))}
      </section>

      <h2 id="complete">Completed Projects</h2>
      <section className="projects-grid" >
        {completed.map(project => (
          <Link to={`/project/${project.id}`} key={project.id} className="project-card">
            <img src={project.image} alt={project.title} />
            <div className="card-content">
              <h3>{project.title}</h3>
              <p>{project.location}</p>
            </div>
          </Link>
        ))}
      </section>

    </section>

    </>
  );
};

export default Projects;
